import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../store/hooks";
import { LatestNewsType } from "../../models";

interface DigitalClockWithNewsProps {
  news: string[];
}

const DigitalClockWithNews: React.FC<DigitalClockWithNewsProps> = ({
  news,
}) => {
  const { latestNews } = useAppSelector((state) => state.common);
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const formattedTime = time.toLocaleTimeString();

  return (
    <div className="bg-gray-900 text-white p-4 rounded-lg shadow-md container-fluid mx-auto">
      {/* Inline Clock and Marquee */}
      <div className="flex items-center space-x-4">
        {/* Clock */}
        <div className="text-xl font-mono whitespace-nowrap">
          {formattedTime}
        </div>

        {/* Marquee container */}
        <div className="relative overflow-hidden h-6 flex-1 bg-gray-800 rounded">
          <div
            className="absolute whitespace-nowrap will-change-transform"
            style={{
              animation: `scroll-left 20s linear infinite`,
            }}
          >
            {latestNews.map((item: LatestNewsType) => (
              <span key={item?.id} className="mx-6 inline-block text-sm">
                🗞️ {item.title}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll animation */}
      <style>
        {`
          @keyframes scroll-left {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-50%);
            }
          }
        `}
      </style>
    </div>
  );
};

export default DigitalClockWithNews;
